/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import createCache from '@emotion/cache'

const createEmotionCache = () => {
  return createCache({ key: 'css' })
}

export default createEmotionCache
